import {Component, inject} from '@angular/core';
import { DatePipe, NgClass } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { ToggleService } from './toggle.service';
import {FeathericonsModule} from "../../icons/feathericons/feathericons.module";
import {LocalstorageService} from "../../services/localstorage.service";
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';
import { AuthService } from '../../services/auth.service';
import { AuthorizationService } from '../../core/services/authorization.service';

@Component({
    selector: 'app-header',
    imports: [MatButtonModule, MatMenuModule, NgClass, FeathericonsModule, TranslateModule],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    providers: [
        DatePipe
    ]
})
export class HeaderComponent {
    private localstorageService = inject(LocalstorageService);
    private router = inject(Router);
    public currentLang = 'es';

    constructor(
        public toggleService: ToggleService,
        private datePipe: DatePipe,
        private translate: TranslateService,
        private languageService: LanguageService,
        private authService: AuthService,
        private authorizationService: AuthorizationService
    ) {
        this.toggleService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
        this.formattedDate = this.datePipe.transform(this.currentDate, 'dd MMMM yyyy');
        
        // Suscribirse al idioma actual
        this.languageService.currentLanguage$.subscribe(lang => {
            this.currentLang = lang;
        });
    }

    // Toggle Service
    isToggled = false;
    toggle() {
        debugger;
        this.toggleService.toggle();
    }

    // Dark Mode
    toggleTheme() {
        this.toggleService.toggleTheme();
    }

    // Current Date
    currentDate: Date = new Date();
    formattedDate: any;

    public logout(): void {
        debugger;
        this.localstorageService.removeItem('token-strong');
        this.localstorageService.removeItem('userData-strong');
        this.router.navigate(['/authentication/sign-in']); // O a tu página de login
    }

    setLanguage(lang: string) {
        this.languageService.setLanguage(lang);
    }

    // Métodos para obtener información del usuario
    getUserEmail(): string {
        const user = this.authService.currentUser();
        return user?.email || '';
    }

    getUserName(): string {
        const user = this.authService.currentUser();
        return user?.name || '';
    }

    getPrimaryRole(): string {
        return this.authorizationService.getPrimaryRole() || '';
    }

    getRoleTranslation(): string {
        const role = this.getPrimaryRole();
        if (role) {
            return this.translate.instant(`ROLES.${role}`);
        }
        return '';
    }
}
